
const createPopupClass = (parentClass) => {
    class Popup extends parentClass {
        position;
        containerDiv;
        constructor(position, content) {
            super();
            this.position = position;
            content.classList.add("popup-bubble");
            // This zero-height div is positioned at the bottom of the bubble.
            const bubbleAnchor = document.createElement("div");
            bubbleAnchor.classList.add("popup-bubble-anchor");
            bubbleAnchor.appendChild(content);
            this.content = content;
            // This zero-height div is positioned at the bottom of the tip.
            this.containerDiv = document.createElement("div");
            this.containerDiv.classList.add("popup-container");
            this.containerDiv.appendChild(bubbleAnchor);
            this.containerDiv.querySelector('.close').onclick = (event) => {
                event.target.parentNode.parentNode.style.display = 'none';
            };
            // Optionally stop clicks, etc., from bubbling up to the map.
            Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
        }
        /** Called when the popup is added to the map. */
        onAdd() {
            let previusPopups = this.getPanes().floatPane.querySelectorAll('.popup-container');
            previusPopups.forEach((popup) => popup.remove());
            this.getPanes().floatPane.appendChild(this.containerDiv);
        }
        /** Called when the popup is removed from the map. */
        onRemove() {
            if (this.containerDiv.parentElement) {
                this.containerDiv.parentElement.removeChild(this.containerDiv);
            }
        }
        /** Called each frame when the popup needs to draw itself. */
        draw() {
            const divPosition = this.getProjection().fromLatLngToDivPixel(
                    this.position
                    );
            // Hide the popup when it is far out of view.
            const display =
                    Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
                    ? "block"
                    : "none";

            if (display === "block") {
                this.containerDiv.style.left = divPosition.x + 4 + "px";
                this.containerDiv.style.top = divPosition.y + 7 + "px";
                let contentPosition = {
                    x: 0,
                    y: 0
                };
                if (divPosition.x < -7) {
                    contentPosition.x = (divPosition.x+70) * -1;
                    if(contentPosition.x > 80) {
                        contentPosition.x = 80;
                    }
                    this.content.style.left = `${contentPosition.x}px`;
                }
                if(divPosition.x > 100) {
                    contentPosition.x = 100 - divPosition.x;
                    if(contentPosition.x < -80) {
                        contentPosition.x = -80;
                    }
                    this.content.style.left = `${contentPosition.x}px`;
                }
            }

            if (this.containerDiv.style.display !== display) {
                this.containerDiv.style.display = display;
            }
        }
    }
    return Popup;
};

export default createPopupClass;